<script setup lang="ts">
const props = withDefaults(defineProps<{ textContent?: string; idx?: number; isTopBottom?: boolean }>(), {
  textContent: '',
  idx: 0,
  isTopBottom: false,
})

const isOverflow = ref(false)

const getPlacement = (idx: number) => {
  const odd = idx % 2 === 1
  return odd ? 'top-start' : 'top-end'
}

const getOffset = (idx: number) => {
  const odd = idx % 2 === 1
  if (props.isTopBottom) return odd ? 0 : 0
  return odd ? 75 : 0
}

const getTextWidth = (text: string) => {
  if (!import.meta.client) return 0
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  if (!context) return 0
  context.font = '600 14px system-ui, -apple-system, sans-serif'
  return context.measureText(text).width
}

const checkTextOverflow = () => {
  isOverflow.value = false
  nextTick(() => {
    const actualWidth = getTextWidth(props.textContent)
    const containerWidth = !props.isTopBottom ? 264 : 338
    isOverflow.value = actualWidth > containerWidth
  })
}

watch(() => props.textContent, checkTextOverflow)
onMounted(checkTextOverflow)
</script>

<template>
  <div :class="['max-w-full min-w-0', isTopBottom ? '!w-[338px]' : '!w-[264px]']">
    <div v-if="!isOverflow" class="text-[14px] font-[600] text-[#3d3d3d]">
      {{ textContent }}
    </div>
    <ElPopover
      v-else
      :teleported="false"
      :id="'lineClamp-' + idx"
      popper-class="license-popover"
      :open-delay="200"
      :placement="getPlacement(idx)"
      trigger="hover"
    >
      <p style="white-space: normal; word-spacing: 0" class="text-[14px] text-[#3D3D3D]">
        {{ textContent }}
      </p>
      <template #reference>
        <p
          :cvs="getPlacement(idx) + getOffset(idx)"
          class="!w-full min-w-0 cursor-pointer truncate text-[14px] font-[600] text-[#3d3d3d]"
        >
          {{ textContent }}
        </p>
      </template>
    </ElPopover>
  </div>
</template>
